import submodule from '../../../@bv/src/i18n/locale/ar';

import account from './account.json';
import ai from './ai.json';
import auth from './auth.json';
import callCenter from './call-center.json';
import callEvaluation from './call-evaluation.json';
import campaigns from './campaigns.json';
import dashboard from './dashboard.json';
import global from './global.json';
import header from './header.json';
import reports from './reports.json';
import settings from './settings.json';
import validations from './validations.json';

export default {
  ai,
  callEvaluation,
  ...submodule,
  ...validations,
  ...auth,
  ...account,
  ...header,
  ...dashboard,
  ...callCenter,
  ...reports,
  ...settings,
  ...campaigns,
  ...global,
};
